module.exports = __webpack_public_path__ + "img/matthias-pro.2c250534.jpg";